import request from '../../../shared/request'

export function getLeadTransmittals(lead_id) {
  return request(`/lead/transmittals/${lead_id}/`)
}

export function getTransmittalData(transmittal_id) {
  return request(`/lead/transmittals/info/${transmittal_id}/`)
}

export function createLeadTransmittal(payload) {
  return request(`/lead/transmittals/${payload.transmittal_data.lead_id}/`, {
    method: 'POST',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function updateLeadTransmittal(payload) {
  return request(`/lead/transmittals/${payload.transmittal_id}/`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function deleteLeadTransmittal(payload) {
  return request(`/lead/transmittals/${payload.transmittal_id}/?leadId=${payload.leadId}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

// attachments
export function uploadAttachments(payload) {
  return request(`/lead/transmittals/${payload.transmittalId}/attachment`, {
    method: 'POST',
    body: payload.formData,
    headers: {
      'content-type': 'multipart/form-data'
    }
  })
}

export function getAttachments(transmittalId) {
  return request(`/lead/transmittals/${transmittalId}/attachments/`)
}

export function updateAttachmentDescription(payload) {
  return request(`/lead/transmittals/${payload.attachmentId}/attachment`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function deleteAttachment(payload) {
  return request(`/lead/transmittals/${payload.attachmentId}/attachment/`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}



// WEBPACK FOOTER //
// ./src/redux/api/lead/transmittals.js